/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { AccountTypes } from "../models";

@Pipe({
  name: "accountTypeLabel"
})
export class AccountTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    return AccountTypes[value as keyof typeof AccountTypes];
  }
}
